import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  style: {
    "margin": "1px"
  }
};
const _hoisted_2 = {
  class: "flex justify-between px-4 py-2"
};
const _hoisted_3 = {
  class: "flex pt-1"
};
const _hoisted_4 = {
  class: "click-menu-custom-1"
};
const _hoisted_5 = {
  key: 0,
  class: "menu"
};
const _hoisted_6 = {
  class: "bg-white shadow-xl rounded absolute px-2 py-3 w-52 z-10 action-menu custom-border border at-action-menu"
};
const _hoisted_7 = {
  class: "cursor-pointer flex"
};
const _hoisted_8 = {
  style: {
    "margin": "1px"
  }
};
const _hoisted_9 = {
  class: "flex felx-row px-4 pb-4"
};
const _hoisted_10 = {
  scope: "col"
};
import draggable from 'vuedraggable';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSwitch from '@/components/LlSwitch.vue';
export default {
  __name: 'CustomFields',
  props: {
    updatePdfState: {
      type: Object,
      required: true
    },
    showSortableModel: {
      type: Boolean,
      default: false
    },
    state: {
      type: Object,
      default: false
    },
    showBorder: {
      type: Boolean,
      required: false,
      default: false
    },
    enable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['closeDialog', 'update:enable', 'toggleConfigureFields'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const goToSettingsPage = () => {
      emit('closeDialog');
      props.state.go('settings.company.customFields');
    };
    const handleUpdateCustomField = value => {
      emit('update:enable', value);
    };
    const toggleCustomFieldsList = fields => {
      if (!fields.isEnabled) {
        props.updatePdfState.disabledCustomFields.push({
          name: fields.name,
          valueType: fields.valueType,
          customFieldId: fields.customFieldId,
          value: fields.value,
          source: fields.source,
          isEnabled: false
        });
        props.updatePdfState.customFieldSettings = props.updatePdfState.customFieldSettings.filter(field => field.customFieldId !== fields.customFieldId);
      } else {
        props.updatePdfState.customFieldSettings.push({
          order: props.updatePdfState.customFieldSettings.length + 1,
          customFieldId: fields.customFieldId,
          name: fields.name,
          valueType: fields.valueType,
          value: fields.value,
          source: fields.source,
          isEnabled: true
        });
        props.updatePdfState.disabledCustomFields = props.updatePdfState.disabledCustomFields.filter(field => field.customFieldId !== fields.customFieldId);
      }
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_chip = _resolveComponent("v-chip");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("hr", _hoisted_1, null, 512), [[_vShow, __props.showBorder]]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.updatePdfState.showEnableCustomFieldsToggle ? (_openBlock(), _createBlock(LlSwitch, {
        key: 0,
        "model-value": __props.enable,
        "onUpdate:modelValue": handleUpdateCustomField,
        label: "Custom Fields"
      }, null, 8, ["model-value"])) : _createCommentVNode("", true), _createElementVNode("div", {
        style: {
          "margin-top": "2px"
        },
        class: "px-2 pt-0.5 pb-1 text-primary cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => goToSettingsPage())
      }, " Go to Custom Fields settings ")]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        variant: "flat",
        "prepend-icon": "mdi-filter-variant",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('toggleConfigureFields'))
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Configure ", -1)]))]),
        _: 1
      })]), __props.showSortableModel ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(draggable), {
        modelValue: __props.updatePdfState.customFieldSettings,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.updatePdfState.customFieldSettings = $event),
        group: "people",
        onStart: _cache[3] || (_cache[3] = $event => _ctx.drag = true),
        onEnd: _cache[4] || (_cache[4] = $event => _ctx.drag = false),
        "item-key": "order"
      }, {
        item: _withCtx(({
          element
        }) => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_v_icon, {
          class: "pt-1.5"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("mdi-drag", -1)]))]),
          _: 1
        }), _createVNode(LlCheckbox, {
          modelValue: element.isEnabled,
          "onUpdate:modelValue": $event => element.isEnabled = $event,
          label: element.name,
          onCheckboxClick: $event => toggleCustomFieldsList(element)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onCheckboxClick"])])]),
        _: 1
      }, 8, ["modelValue"]), _withDirectives(_createElementVNode("hr", _hoisted_8, null, 512), [[_vShow, __props.updatePdfState?.disabledCustomFields?.length]]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updatePdfState.disabledCustomFields, (fields, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "flex felx-row"
        }, [_cache[8] || (_cache[8] = _createElementVNode("span", {
          class: "px-2.5"
        }, null, -1)), _createVNode(LlCheckbox, {
          modelValue: fields.isEnabled,
          "onUpdate:modelValue": $event => fields.isEnabled = $event,
          label: fields.name,
          onCheckboxClick: $event => toggleCustomFieldsList(fields)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onCheckboxClick"])]);
      }), 128))])])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [_createVNode(_unref(draggable), {
        modelValue: __props.updatePdfState.customFieldSettings,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => __props.updatePdfState.customFieldSettings = $event),
        tag: "tr",
        class: "overflow-x-auto",
        "item-key": key => key
      }, {
        item: _withCtx(({
          element: customField
        }) => [_createElementVNode("th", _hoisted_10, [_createVNode(_component_v_chip, {
          class: "mx-1 cursor-pointer",
          label: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(customField.name), 1)]),
          _: 2
        }, 1024)])]),
        _: 1
      }, 8, ["modelValue", "item-key"])])], 64);
    };
  }
};